// extracted by mini-css-extract-plugin
module.exports = {"root":"privacyPolicy_root__2cOfR","container":"privacyPolicy_container__2EkAh","newText":"privacyPolicy_newText__OWqzh"};